<template>
  <ValidationObserver
    ref="observer"
    v-slot="{ valid, dirty }"
  >
    <NavTabs
      :tabs="tabs"
      :activeTab="newActiveTab"
      @sendData="updateData"
    />

    <SlotScopeWatcher
      :value="dirty"
      @change="$emit('dirtyChanged', dirty)"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import NavTabs from '@/components/shared/widgets/Nav-tabs.vue';
import Analysis from '@/components/nodes/controlChart/Analysis';
import Chart from '@/components/nodes/controlChart/Chart';
import lockService from '@/utilities/lockService';


export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        NavTabs,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
        actionName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            tabs: [],
            components: [Analysis, Chart],
            controlChart: [],
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'userLang',
        ]),
        newActiveTab: {
            get() {
                return this.activeTab;
            },
            set(newValue) {
                this.$store.dispatch('changeActiveTab', newValue);
            },
        },
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },
    async created() {
        const { data } = await this.$rq.getControlChart(this.node.ref);
        this.controlChart = data.controlChart;
        this.tabs = this.tableHeaders();
        this.$store.commit('clearAnalyses');
    },
    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, this.actionName);
        }
        window.removeEventListener('beforeunload', this.handleUnload);
    },

    methods: {
        tableHeaders() {
            const headers = this.components.map((component, index) => ({
                index,
                props: { node: this.node, controlChart: this.controlChart },
                name: this.$t(`controlChart.tab${index}.title`),
                component: Vue.component(`tab-${index}`, component),
            }));
            this.$store.dispatch('setTabs', headers);
            return headers;
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, this.actionName);
            }
        },
        updateData(newData) {
            this.$emit('sendData', newData);
        },
    },
};
</script>
